export default {
  properties: {
    caseId: {
      type: 'number',
      title: 'Identyfikator sprawy MDOK'
    },

    target: {
      default: 1,
      enum: [1, 2],
      type: 'number',
      title: 'Miejsce zapisu dokumentu'
    }
  },
  type: 'object'
};
